import { render, staticRenderFns } from "./Router.vue?vue&type=template&id=50084d87"
import script from "./Router.vue?vue&type=script&lang=js"
export * from "./Router.vue?vue&type=script&lang=js"
import style0 from "./Router.vue?vue&type=style&index=0&id=50084d87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports